import { MutationTree } from 'vuex';
import { TChatStoreState } from './state';
import { TChatInputCacheConfig, TRevokeMessageTimestampConfig } from './typings';
import { StorageManager } from '_c/business/storage';
import { GetTopicInfoItem, TopicInfo } from '_c/typings/proto';

export interface IEditPanelTopicMapOptions {
  channelId: string;
  topicInfo: TopicInfo;
}

export interface ITopicInfoMapOptions {
  topicId: string;
  topicInfo: GetTopicInfoItem;
}

export interface ITopicJoinCountOptions {
  topicId: string;
  count: number;
}

const mutations: MutationTree<TChatStoreState> = {
  setChatInputCacheConfig(state, { key, value }: TChatInputCacheConfig) {
    if (value) {
      state.chatInputCacheConfig = {
        ...state.chatInputCacheConfig,
        [key]: value,
      };
    } else {
      if (state.chatInputCacheConfig[key]) {
        delete state.chatInputCacheConfig[key];
      }
    }
    window.sessionStorage.setItem('chatInputCacheConfig', JSON.stringify(state.chatInputCacheConfig));
  },
  setPicCacheConfig(state, { key, value }) {
    if (value) {
      state.picCacheConfig = {
        ...state.picCacheConfig,
        [key]: value,
      };
    } else {
      if (state.picCacheConfig[key]) {
        delete state.picCacheConfig[key];
      }
    }
    window.sessionStorage.setItem('picCacheConfig', JSON.stringify(state.picCacheConfig));
  },
  setPanelCheckedIndex(state, index) {
    state.panelCheckedIndex = index;
  },
  setPanelListLength(state, length) {
    state.panelListLength = length;
  },
  setChannelCheckedIndex(state, index) {
    state.channelCheckedIndex = index;
  },
  setChannelListLength(state, length) {
    state.channelListLength = length;
  },
  setRevokeMessageTimestamp(state, { messageUniqueId, timestamp }: {messageUniqueId: string, timestamp: number}) {
    if (timestamp) {
      state.revokeMessageTimestampConfig[messageUniqueId] = timestamp;
    } else {
      delete state.revokeMessageTimestampConfig[messageUniqueId];
    }
    StorageManager.getInstance().set<TRevokeMessageTimestampConfig>('revokeMessageTimestampConfig', state.revokeMessageTimestampConfig);
  },
  setTopicInfoMap(state, { topicId, topicInfo }: ITopicInfoMapOptions) {
    state.topicInfoMap[topicId] = topicInfo;
  },
  setTopicJoinCount(state, { topicId, count }: ITopicJoinCountOptions) {
    if (state.topicInfoMap[topicId]) {
      const joinCount = parseInt(state.topicInfoMap[topicId].topicInfo.joinCnt, 10);
      state.topicInfoMap[topicId].topicInfo.joinCnt = (joinCount + count).toString();
    }
  },
};

export default mutations;
